export default {
      id: "common__more-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__more",
      toString: function () {
        return this.url;
      }
    }